export abstract class EventController {
  static eventName: string;
  static args: any;
}

export function subscribe(
  eventClass: { eventName: string; args: any },
  func: (details: any) => void
): { unsubscribe: () => void } {
  const handler = function () {
    func(eventClass.args);
  };
  document.addEventListener(eventClass.eventName, handler, { passive: true });
  return {
    unsubscribe: function unsubscribe() {
      document.removeEventListener(eventClass.eventName, handler);
    }
  };
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function publish(event: any): void {
  const nativeEvent = new CustomEvent(event.constructor.eventName, {
    detail: event.constructor.args
  });
  document.dispatchEvent(nativeEvent);
}

export class ElevationController extends EventController {
  static override eventName: string;
  static override args: Map<number, number>;

  constructor(level: number, remove?: boolean) {
    super();
    ElevationController.eventName = 'eleLevel';
    if (!ElevationController.args) {
      ElevationController.args = new Map();
    }
    if (remove && ElevationController.args.has(level)) {
      const val = ElevationController.args.get(level) ?? 0;
      if (val === 0) {
        return;
      }
      if (val === 1) {
        ElevationController.args.delete(level);
      } else ElevationController.args.set(level, val - 1);
    } else if (!remove) {
      const val = ElevationController.args.has(level)
        ? ElevationController.args.get(level) ?? 0
        : 0;
      ElevationController.args.set(level, val + 1);
    }
  }

  static overlays(elevation: number): boolean {
    if (ElevationController.args.size === 0) {
      return false;
    }
    let overlayPresent = false;
    ElevationController.args.forEach((_, key) => {
      if (key > elevation) {
        overlayPresent = true;
      }
    });
    return overlayPresent;
  }
}

export const Elevations = {
  /**
   * Add elevation to the elevation controller service and publishes a event that other components can listen.
   * @param props elevation number the needs to be added
   */
  add: (elevation: number): void => publish(new ElevationController(elevation)),
  /**
   * Removes elevation to the elevation controller service and publishes a event that other components can listen.
   * @param props elevation number the needs to be removed
   */
  remove: (elevation: number): void =>
    publish(new ElevationController(elevation, true)),
  /**
   * pass an elevation number to check if there are elements with more elevation on the screen.
   * @param props elevation number that we need to check
   * @returns boolean indicating if higher elevations are present
   */
  overlays: (elevation: number): boolean =>
    ElevationController.overlays(elevation)
};
